import React from 'react';
import { Divider, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

export default () => (
    <div className="page">
        <Typography>
            <Title level={2}>結果與輸出</Title>

            <Divider orientation="left" orientationMargin="0"><Title level={4}>一、常規排班方案</Title></Divider>
            <Paragraph>
                <Text>點擊左側“結果——排班方案”可查看常規排班結果。結果支持多維度查看。<br /></Text>
                <Title level={5}>1、員工角度</Title>
                <Text>表格當前所有員工的基本信息，支持搜索篩選，找到對應員工可在“操作”列選擇查看其對應的排班信息。下方的詳情表會根據選擇的員工展示對應的排班結果。</Text>

                <Title level={5}>2、訂單角度</Title>
                <Text>
                    支持四類結果查看：<br />
                    （1）全體員工排班結果<br />
                    （2）舊單重排結果<br />
                    （3）新餐飲訂單排班結果<br />
                    （4）新非餐飲訂單排班結果<br />
                </Text>
            </Paragraph>

            <Divider orientation="left" orientationMargin="0"><Title level={4}>二、STI排班方案</Title></Divider>
            <Paragraph>
                <Text>點擊左側“結果——STI排班方案”可查看STI排班結果。</Text>
            </Paragraph>
        </Typography>
    </div>
);
